import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FiLogOut,
  FiHome,
  FiActivity,
  FiDollarSign,
  FiUsers,
  FiDatabase,
  FiLayers,
  FiUser,
  FiBarChart2,
} from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";
import { handleLogout } from "../login/AuthUtils";
import "./Sidebar.css";
import logo from "../logo.jpg";

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [adminOpen, setAdminOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const navigate = useNavigate();

  const toggleAdmin = () => setAdminOpen(!adminOpen);
  const toggleReport = () => setReportOpen(!reportOpen);

  const onLogout = () => {
    handleLogout();
    navigate("/login");
  };

  const menuItem = [
    { path: "/", name: "Tasks", icon: <FiHome /> },
    { path: "/activity", name: "Activity", icon: <FiActivity /> },
    { path: "/payments", name: "Payments", icon: <FiDollarSign /> },
    { path: "/charges", name: "Charges", icon: <FiLayers /> },
    { path: "/rate", name: "Rate", icon: <FiDatabase /> },
    // { path: "/users", name: "Users", icon: <FiUsers /> },
    { path: "/account", name: "Account", icon: <FiUser /> }, // ✅ Added Account
  ];

  const adminMenu = [
    { path: "/admin/upload", name: "📤 Upload Data" },
    { path: "/admin/task", name: "📝 Update Task" },
    { path: "/admin/activity", name: "📊 Update Activity" },
    { path: "/admin/charges", name: "💰 Update Charges" },
    { path: "/admin/users", name: "👥 Manage Users" },
  ];

  const reportMenu = [
    { path: "/report/user", name: "👤 UserWise Report" },
    { path: "/report/project", name: "📁 ProjectWise Report" },
  ];

  return (
    <div className="container-sidebar">
      <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
        {/* Logo */}
        <div className="top-section">
          <h2 className="logo">
            {isOpen ? (
              <>
                <img src={logo} alt="Logo" className="logo-img" />
                <span className="logo-text">TransAcct</span>
              </>
            ) : (
              "logo"
            )}
          </h2>
        </div>

        {/* Main Menu Items */}
        <div className="menu">
          {menuItem.map((item, index) => (
            <NavLink
              to={item.path}
              key={index}
              className={({ isActive }) =>
                isActive ? "menu-link active" : "menu-link"
              }
            >
              <span className="icon">{item.icon}</span>
              {isOpen && <span className="link-text">{item.name}</span>}
            </NavLink>
          ))}

          {/* Admin Dropdown */}
          <div className="dropdown">
            <div
              className={`menu-link ${adminOpen ? "active" : ""}`}
              onClick={toggleAdmin}
            >
              <span className="icon">
                <FiDatabase />
              </span>
              {isOpen && (
                <>
                  <span className="link-text">Admin</span>
                  <FaChevronDown
                    className={`chevron ${adminOpen ? "rotate" : ""}`}
                  />
                </>
              )}
            </div>

            {adminOpen && isOpen && (
              <div className="submenu">
                {adminMenu.map((sub, idx) => (
                  <NavLink
                    to={sub.path}
                    key={idx}
                    className={({ isActive }) =>
                      isActive ? "submenu-link active" : "submenu-link"
                    }
                  >
                    {sub.name}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          {/* ✅ Report Dropdown */}
          <div className="dropdown">
            <div
              className={`menu-link ${reportOpen ? "active" : ""}`}
              onClick={toggleReport}
            >
              <span className="icon">
                <FiBarChart2 />
              </span>
              {isOpen && (
                <>
                  <span className="link-text">Report</span>
                  <FaChevronDown
                    className={`chevron ${reportOpen ? "rotate" : ""}`}
                  />
                </>
              )}
            </div>

            {reportOpen && isOpen && (
              <div className="submenu">
                {reportMenu.map((sub, idx) => (
                  <NavLink
                    to={sub.path}
                    key={idx}
                    className={({ isActive }) =>
                      isActive ? "submenu-link active" : "submenu-link"
                    }
                  >
                    {sub.name}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Logout */}
        <div className="bottom-section">
          <button className="logout-btn" onClick={onLogout}>
            <FiLogOut />
            {isOpen && <span className="ms-2">Logout</span>}
          </button>
        </div>
      </div>

      <div className="main-content">{children}</div>
    </div>
  );
};

export default Sidebar;
